
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/waianapanapa/change",
      function () {
        return require("private-next-pages/waianapanapa/change.js");
      }
    ]);
  